module.exports = __webpack_public_path__ + "img/builderall-marketing-suite.039ce9eb.svg";